import * as React from 'react';
import { TextInput } from "soprasteria-ui-library";
import { dateTimeToDateString } from '../../../helpers/DateHelper';
import { IReferral } from '../../../models/IReferral';

interface IReferralStatus {
    referral?: IReferral;
}

export const ReferralStatus: React.FunctionComponent<IReferralStatus> = ({ referral }) => {

    return (
        <>
            {
                referral?.referralStatus || referral?.dateSent  || referral?.dateReceived ?
                    <>
                        <div className="row readonly-less-margin">
                            <div className="col-6">
                                <TextInput name="dateSentReadonly" label="Datum skickad" defaultValue={referral?.dateSent ? dateTimeToDateString(referral.dateSent) : "-"} inlineLabel readonly />
                            </div>
                            {
                                referral?.referralStatus ?
                                    <div className="col-6">
                                        <TextInput name="referralStatusReadOnly" label="Status" defaultValue={referral?.referralStatus} readonly inlineLabel />
                                    </div>
                                    : null

                            }
                            <div className="col-6">
                                <TextInput name="dateReceivedReadonly" label="Datum godkänd" defaultValue={referral?.dateReceived ? dateTimeToDateString(referral.dateReceived) : "-"} inlineLabel readonly />
                            </div>
                            <div className="col-6">
                                <TextInput name="dateClosedReadonly" label="Datum avslutad" defaultValue={referral?.closedDate ? dateTimeToDateString(referral.closedDate) : "-"} inlineLabel readonly />
                            </div>
                        </div>
                        <hr />
                    </>
                    : null
            }
        </>
    );
}